import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import * as React from "react";
import { IMaskInput } from "react-imask";

interface IMaskInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value?: string;
}

const NumberMaskInput = React.forwardRef<HTMLInputElement, IMaskInputProps>(
  (props, ref) => {
    const { onChange, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask={Number}
        scale={2}
        thousandsSeparator=""
        padFractionalZeros={true}
        normalizeZeros={true}
        radix="."
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
        unmask={false}
      />
    );
  }
);

interface NumberTextFieldProps {
  label?: string;
  name: string;
  value?: string | number;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  helperText?: string;
  required?: boolean;
  small?: boolean;
  error?: boolean;
  sx?: React.CSSProperties;
}

export default function NumberTextField({
  label,
  name,
  value: propValue = "",
  onChange,
  onBlur,
  helperText,
  required = false,
  small = false,
  error: propError = false,
  sx = {},
}: NumberTextFieldProps) {
  const [internalValue, setInternalValue] = React.useState(
    propValue?.toString() || ""
  );
  const [error, setError] = React.useState(propError);

  // 同步外部value变化
  React.useEffect(() => {
    setInternalValue(propValue?.toString() || "");
  }, [propValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInternalValue(newValue);
    onChange?.(newValue);
  };

  const handleBlur = () => {
    const isValid = !required || (internalValue && internalValue.trim() !== "");
    setError(!isValid);
    onBlur?.();
  };

  return (
    <Stack direction="row" spacing={2}>
      <FormControl variant="standard" error={error} fullWidth>
        {label && (
          <InputLabel shrink htmlFor={`number-input-${name}`}>
            {label}
          </InputLabel>
        )}
        <OutlinedInput
          sx={{
            "& input": {
              // padding: "8.5px 14px"
              padding: "12px 14px",
            },
            width: small ? "100px" : "100%",
            ...sx,
          }}
          id={`number-input-${name}`}
          value={internalValue}
          onChange={handleChange}
          onBlur={handleBlur}
          inputComponent={NumberMaskInput as any}
          inputProps={{
            name,
          }}
          aria-describedby={`${name}-helper-text`}
        />
        {(error || helperText) && (
          <FormHelperText id={`${name}-helper-text`}>
            {error ? helperText || "This field is required" : helperText}
          </FormHelperText>
        )}
      </FormControl>
    </Stack>
  );
}
